import type { ReactNode } from "react";
import { Box } from "@mui/material";

export default function SignInLayout({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "100vh",
        overflow: "auto",
      }}
    >
      <Box width="568px" my={5}>
        {children}
      </Box>
    </Box>
  );
}
